const getNextObjectKey = (objects: any, property: any): number =>
  objects.reduce(
    (max: number, object: any) =>
      object[property] > max ? object[property] : max,
    0
  ) + 1;

export default getNextObjectKey;
